// Причина несостоявшегося запуска в том виде, в каком её показывает лента чата.

import { ApiError } from "~/shared/api/client";
import type { ChatGenerationError } from "~/shared/store/useChatErrorsStore";

/**
 * Запись об ошибке запуска генерации.
 *
 * Статус и код осмысленны только когда бэкенд ответил: по ним лента отличает
 * «чат уже занят» от «кончились деньги» и решает, предлагать ли повтор. Сорвался
 * сам запрос — остаётся текст, и приписывать ему статус нельзя, иначе ошибка
 * сети выглядела бы отказом сервера.
 */
export function toChatGenerationError(err: unknown): ChatGenerationError {
    if (err instanceof ApiError) {
        return { message: err.message, statusCode: err.status, code: err.code };
    }
    if (err instanceof Error) return { message: err.message };
    return { message: "Не удалось запустить генерацию" };
}
